/**
 * @file roles.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los distintos roles disponibles
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-03-06
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

export const USER_ROLES = [
  { value: "admin", label: "admin" },
  { value: "user", label: "user" },
] as const;
